<!-- 用户基本信息 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户手机号')">
              <a-input :placeholder="$t('请输入用户手机号')" v-model="queryParam.userPhone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户姓名')">
              <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="userId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :class="{'top-table': selectedRowKeys.length>0}"
        :customRow="customRow"
        :rowSelection="{type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="userStateSlot" slot-scope="text">
          <a-button :class="text == 1?'normalbg-status':text == 0?'unactivebg-status':''">
            {{text==1?$t('已激活'):text==0?$t('未激活'):''}}
          </a-button>
        </template>
        <span slot="wtPriceSlot" slot-scope="text, record" :title="record.wtName?record.wtName+'('+record.wtTotalPrice+')':''">
          <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
          <span v-else>--</span>
        </span>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>


        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <div class="" v-if="selectedRowKeys.length>0">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" :tab="$t('交易记录')">
          <DeductionRecord :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('缴费记录')">
          <PaymentRecords :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="3" :tab="$t('微信故障报修申请')">
          <WeChatApplicationRecord :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="4" :tab="$t('微信申请')">
          <WeChatApplication :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="5" :tab="$t('表具实时数据')">
          <MeterUpDataList :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="6" :tab="$t('日用量报表')">
          <DailyUsageReport :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="7" :tab="$t('命令服务队列')">
          <CommandManagement :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="8" :tab="$t('调价记录')">
          <PriceAdjustmentRecord :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="9" :tab="$t('换表记录')">
          <RecordOfTableReplacement :id="selectedRowKeys[0]" />
        </a-tab-pane>
        <a-tab-pane key="10" :tab="$t('过户记录')">
          <TransferRecord :id="selectedRowKeys[0]" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    Mn100FkStatusObj
  } from '@/utils/constants/protocolConstant'
  import {
    isUndefined
  } from '@/utils/validate'
  import DeductionRecord from './DeductionRecord'
  import PaymentRecords from './PaymentRecords'
  import WeChatApplicationRecord from './WeChatApplicationRecord'
  import WeChatApplication from './WeChatApplication'
  import MeterUpDataList from './MeterUpDataList'
  import RecordOfTableReplacement from './RecordOfTableReplacement'
  import DailyUsageReport from './DailyUsageReport'
  import CommandManagement from './CommandManagement'
  import PriceAdjustmentRecord from './PriceAdjustmentRecord'
  import TransferRecord from './TransferRecord'

  export default {
    name: 'BasicUserInformation',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      JInput,
      DeductionRecord,
      PaymentRecords,
      WeChatApplicationRecord,
      WeChatApplication,
      MeterUpDataList,
      RecordOfTableReplacement,
      DailyUsageReport,
      CommandManagement,
      PriceAdjustmentRecord,
      TransferRecord
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/meter/meterUserinfo/list",
        },
        queryParam: {},
      }
    },
    created() {},
    mounted(){},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('用户状态'),
            align:"center",
            dataIndex:'userState',
            scopedSlots: { customRender: 'userStateSlot' },
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex:'meterId',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('表类型'),
            dataIndex:'meterTypeName',
            align:"center",
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender: (t, r, index) => {
              let data = Mn100FkStatusObj;
              if (isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('激活时间'),
            align:"center",
            dataIndex: 'userActivateTime',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('价格信息'),
            align:"center",
            dataIndex: 'wtPrice',
            scopedSlots: { customRender: 'wtPriceSlot' },
            width: 200,
            ellipsis: true,
          },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   fixed:"right",
          //   width:150,
          //   scopedSlots: { customRender: 'action' }
          // }
        ]
      }
    },
    methods: {
      // 上面选择
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
      },
      customRow(record, index) {
        return {
          on: {
            click: (e) => {
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
            }
          }
        }
      },
    }
  }
</script>
<style scoped lang="less">
  @import '~@assets/less/common.less';
  .top-table{
    border-bottom: 2px dashed #666;
  }
  /deep/.ant-table-body{
    height: 350px;
    .ant-table-thead{
      position: sticky;
      top: 0;
      z-index: 1;
    }
  }
</style>